import React, { useRef, useState } from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import ContinueEnabled from '../Buttons/ContinueEnabled'
import ContinueDisabled from '../Buttons/ContinueDisabled'
import PrivacyTerms from '../PrivacyTerms/PrivacyTerms'
import './OTPVerify.css'
import '../Buttons/continueenabled.css'
import OtpInput from './OtpInput'
import CountdownTimer from './CountdownTimer'
import axios from 'axios';
import Toastify from 'toastify-js'
import { pushEvent, EVENTS } from '../../utils/dataLayer';

function OTPComponents({ phone, otp, setOtp, onContinue, disabled }) {
    // const [otp, setOtp] = useState([]);
    const [resend, setResentOTP] = useState(false);
    const [resetSignal, setResetSignal] = useState(0);

    const handleOtpInput = (otp) => {
        setOtp(otp)
    }

    const handleOtpChange = (val) => {
        setOtp(val);
    };

    // 
    const handleOnTimeOut = () => {
        setResentOTP(true)
    }

    const resendOTP = async () => {
        setResetSignal(prev => prev + 1); // Reset timer by changing key
        setResentOTP(false)
        const data = {
            phone
        };
        await axios.post(`${process.env.REACT_APP_API_URL}/send-otp`, data)
            .then((response) => {
                console.log(response.data);
                const res = response.data;
                const msg = res.Podcast_App[0].msg;
                const success = res.Podcast_App[0].success;
                if (success === "1") pushEvent(EVENTS.OTP_RESEND);

                Toastify({
                    text: msg,
                    duration: 3000,
                    newWindow: true,
                    close: true,
                    gravity: "bottom", // `top` or `bottom`
                    position: "center", // `left`, `center` or `right`
                    stopOnFocus: true, // Prevents dismissing of toast on hover
                    style: {
                        background: "linear-gradient(to right, #000000ff, #000000ff)",
                    },
                    onClick: function () { } // Callback after click
                }).showToast();

            })
            .catch((error) => {
            });
    }

    return (
        <Row>
            <Col md={12} xs={12}>
                <Image src={`${process.env.PUBLIC_URL}/logo/dastaan_logo.jpg`} className='login-logo' alt="logo" title="Dastaan" />
            </Col>
            <Col md={12} xs={12} className='login-continue-wrapper'>
                <span className='login-continue-txt white-text'>OTP Verification</span>
            </Col>
            <Col md={12} xs={12} className='otp-sent-wrapper'>
                <span className='otp-sent-txt'>OTP has been sent to +91 {phone}</span>
            </Col>
            <Col md={12} xs={12} >
                <OtpInput onComplete={handleOtpInput} onChange={handleOtpChange} />
                <CountdownTimer
                    initialSeconds={30}
                    onTimeout={handleOnTimeOut}
                    resetSignal={resetSignal}
                />

            </Col>
            <Col md={12} xs={12} style={{ marginTop: "-25px" }} >
                <span className={`resend-now ${resend === false ? 'disabled-resend' : 'enable-resend'}`} onClick={resend === true ? resendOTP : undefined}>Resend now</span>
            </Col>
            <Col md={12} xs={12}>
                {otp !== undefined && otp.length === 4 ? <ContinueEnabled onContinue={onContinue} disabled={disabled} label="Verify OTP" /> : <ContinueDisabled label="Verify OTP" />}
            </Col>
        </Row>
    )
}
export default OTPComponents